import { render, staticRenderFns } from "./VDiscordIcon.vue?vue&type=template&id=09b2b944&scoped=true"
import script from "./VDiscordIcon.vue?vue&type=script&lang=js"
export * from "./VDiscordIcon.vue?vue&type=script&lang=js"
import style0 from "./VDiscordIcon.vue?vue&type=style&index=0&id=09b2b944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b2b944",
  null
  
)

export default component.exports